// extracted by mini-css-extract-plugin
module.exports = {"downloadSection":"DownloadSection_downloadSection__RiMBv"};